import { render, staticRenderFns } from "./FilterPillsList.vue?vue&type=template&id=4730c8f8&scoped=true&"
import script from "./FilterPillsList.vue?vue&type=script&lang=js&"
export * from "./FilterPillsList.vue?vue&type=script&lang=js&"
import style0 from "./FilterPillsList.vue?vue&type=style&index=0&id=4730c8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730c8f8",
  null
  
)

export default component.exports